export var CallSortType;
(function (CallSortType) {
    CallSortType[CallSortType["QUEUE_STARTED_ASC"] = 4] = "QUEUE_STARTED_ASC";
    CallSortType[CallSortType["QUEUE_STARTED_DESC"] = 5] = "QUEUE_STARTED_DESC";
    CallSortType[CallSortType["QUEUE_ENDED_ASC"] = 6] = "QUEUE_ENDED_ASC";
    CallSortType[CallSortType["QUEUE_ENDED_DESC"] = 7] = "QUEUE_ENDED_DESC";
    CallSortType[CallSortType["CALL_STARTED_ASC"] = 10] = "CALL_STARTED_ASC";
    CallSortType[CallSortType["CALL_STARTED_DESC"] = 11] = "CALL_STARTED_DESC";
    CallSortType[CallSortType["CALL_DURATION_ASC"] = 12] = "CALL_DURATION_ASC";
    CallSortType[CallSortType["CALL_DURATION_DESC"] = 13] = "CALL_DURATION_DESC";
    CallSortType[CallSortType["CALL_ENDED_ASC"] = 14] = "CALL_ENDED_ASC";
    CallSortType[CallSortType["CALL_ENDED_DESC"] = 15] = "CALL_ENDED_DESC";
    CallSortType[CallSortType["WAIT_TIME_ASC"] = 20] = "WAIT_TIME_ASC";
    CallSortType[CallSortType["WAIT_TIME_DESC"] = 21] = "WAIT_TIME_DESC";
    CallSortType[CallSortType["COUNTRY_ASC"] = 30] = "COUNTRY_ASC";
    CallSortType[CallSortType["COUNTRY_DESC"] = 31] = "COUNTRY_DESC";
    CallSortType[CallSortType["CREATION_DATE_ASC"] = 40] = "CREATION_DATE_ASC";
    CallSortType[CallSortType["CREATION_DATE_DESC"] = 41] = "CREATION_DATE_DESC";
})(CallSortType || (CallSortType = {}));
//# sourceMappingURL=call-sort-type.js.map